"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.Side = void 0;

var React = _interopRequireWildcard(require("react"));

var _CommonChrome = _interopRequireDefault(require("../CommonChrome"));

var Side = function Side() {
  return /*#__PURE__*/React.createElement(_CommonChrome["default"].Nav, {
    vertical: true,
    inverted: true
  });
};

exports.Side = Side;
var _default = Side;
exports["default"] = _default;